// Context
import Modal from "../common/Modal";
import { useAuth } from "../../hooks/useAuth";
import Switch from "react-switch";
import { usePostMessages } from "../../hooks/usePostMessages";
import { useState } from "react";
import api from "../../services/api";
import { useTranslation } from "react-i18next";

function ModalDevSettings({ close, show }) {
  const { isOnline, auth, isDebugMode, setIsDebugMode, setIsOnline, brand } = useAuth();
  const { sendSetConnectionStatus, sendSetIframeURL, sendSetIframeLocal } = usePostMessages();
  const [url, setUrl] = useState(window.location.origin);
  const [extensionId, setExtensionId] = useState(() => {
    if (auth?.user?.custom?.extensionId) {
      return auth.user.custom.extensionId;
    }

    if (brand === "rpg") {
      return process.env.REACT_APP_EXTENSION_ID_RPG || "";
    }

    if (brand === "healcore") {
      return process.env.REACT_APP_EXTENSION_ID_HEALCORE || "";
    }

    return process.env.REACT_APP_EXTENSION_ID || "";
  });
  const { t } = useTranslation();

  const toggleOnline = (val) => {
    sendSetConnectionStatus(val);
    setIsOnline(val);
    close();
  };

  const openLocal = () => {
    sendSetIframeLocal();
  };

  const save = () => {
    sendSetIframeURL(url);
    close();
  };

  const saveExtensionId = async () => {
    await api.updateProfile({
      custom: { extensionId: extensionId },
    });

    window.location.reload();
  };

  return (
    <Modal show={show} close={close} size="medium" title={t("layout.devSettings.title")}>
      <div className="row-form vertical-align">
        <label>{t("layout.devSettings.iframeUrl")}</label>
        <input type="text" value={url} onChange={(e) => setUrl(e.target.value)} />
      </div>

      <div className="row-form vertical-align">
        <label>{t("layout.devSettings.isOnline")}</label>
        <Switch
          checked={isOnline}
          onChange={(e) => toggleOnline(e)}
          uncheckedIcon={false}
          checkedIcon={false}
          height={24}
          width={45}
          className="mr-10"
        />
      </div>

      <div className="row-form vertical-align">
        <label>{t("layout.devSettings.enableDebug")}</label>
        <Switch
          checked={isDebugMode}
          onChange={(e) => setIsDebugMode(e)}
          uncheckedIcon={false}
          checkedIcon={false}
          height={24}
          width={45}
          className="mr-10"
        />
      </div>

      <div className="row-form vertical-align">
        <label>{t("layout.devSettings.env")}</label>
        <input type="text" value={process.env.REACT_APP_ENV} disabled />
      </div>

      <button onClick={openLocal} className="mb-20">
        {t("layout.devSettings.goLocal")}
      </button>

      <input type="text" value={extensionId} onChange={(e) => setExtensionId(e.target.value)} className="mb-10" />
      <button onClick={saveExtensionId} className="mt-20 mb-30">
        {t("layout.devSettings.saveExtensionId")}
      </button>

      <div className="row-form ">
        <label>{t("layout.devSettings.envVars")}</label>
        <pre>{JSON.stringify(process.env, 2, 2)}</pre>
      </div>

      <div className="row-form ">
        <label>{t("layout.devSettings.auth")}</label>
        <pre>{JSON.stringify(auth, 2, 2)}</pre>
      </div>

      <div className="modal-actions">
        <button onClick={save}>{t("layout.devSettings.save")}</button>
      </div>
    </Modal>
  );
}

export default ModalDevSettings;
